import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/LeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate, useParams, Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from '../../components/ui/toast';
import { ArrowLeft, MapPin, User } from "lucide-react";

function ShipmentTracking() {
    let navigate = useNavigate();
    const { slip_no } = useParams();
    const [status, setStatus] = useState([]);
    const { headers1, headers2, logout } = AuthUser();
    useEffect(() => {
        GetTrackingDetails();
    }, []);

    const GetTrackingDetails = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'Customershipmentdetailsbyslipno',
            headers: headers1,
            data: {
                slip_no: slip_no
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var statusdata = response.data.value.shipmentallstatus;
                    setStatus(statusdata);
                }
                else {
                    setStatus([]);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <div className="px-pagehead">
                        <div className="px-pagehead__left">
                            <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                                <ArrowLeft size={16} />
                            </button>
                            <h2 className="px-pagehead__title">AWB #{slip_no}</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="px-card">
                                <div className="px-card__head">
                                    <span className="px-card__title"><MapPin size={16} />Shipment Tracking</span>
                                </div>
                                <div className="px-card__body">
                                    {status != undefined && status != '' ?
                                        <ul className="px-timeline">
                                            {status.map((st, i) => (
                                                <li className="px-timeline__item" key={i}>
                                                    <span className="px-timeline__dot"><User size={12} /></span>
                                                    <div className="px-timeline__body">
                                                        <div className="px-timeline__time">{st.pickup_time}</div>
                                                        <div className="px-timeline__title">{st.Details}</div>
                                                        <div className="px-timeline__city">{st.city}</div>
                                                        {st.Activites && <div className="px-timeline__act">{st.Activites}</div>}
                                                        <small className="px-muted-sm">Updated By: {st.name}</small>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        :
                                        <div className="px-empty">Record Not Found</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}
export default ShipmentTracking;
